module.exports = __webpack_public_path__ + "img/map1.5eff740c.png";